import { Pipe, PipeTransform } from '@angular/core';
import {DecimalPipe} from "@angular/common";

@Pipe({
  name: 'throughputCalculation'
})
export class ThroughputCalculationPipe implements PipeTransform {

  constructor(
      private decimalPipe: DecimalPipe
  ) {
  }
  transform(value : number, interval: number): any {
    if (value && interval) {
      const bits = value * 8;
      const megabits = bits / 1000 / 1000;
      const rate = interval / 1000;

      if (rate == 0) {
        return 0;
      }
      return `${this.decimalPipe.transform(megabits / rate, "1.2-2")}` + ' Mbps'
    }
  }
}